'use client';

import { useCadrinoCopy } from '@/lib/cadrino-landing/useCadrinoCopy';
import { Container, Section, SectionHeader, MotionBlock, ContentCard, CardKicker, CardText, CardOutcome, cardGridClass, sectionBandClass } from './shared';
export function UseCases() {
  const c = useCadrinoCopy();
  return <Section className={sectionBandClass('muted')}>
      <Container>
        <MotionBlock>
          <SectionHeader title={c.useCases.title} subtitle={c.useCases.subtitle} />
        </MotionBlock>

        <div className={cardGridClass}>
          {c.useCases.items.map((item, i) => <MotionBlock key={item.industry} delay={i * 0.04}>
              <ContentCard>
                <CardKicker>{item.industry}</CardKicker>
                <CardText className="mt-3 flex-1">{item.pain}</CardText>
                <CardOutcome>{item.benefit}</CardOutcome>
              </ContentCard>
            </MotionBlock>)}
        </div>
      </Container>
    </Section>;
}